import { EventEmitter } from "eventemitter3";
import { environment } from "src/environments/environment";

import { Event, Room, Actor } from "./types";

export const onActorPropertiesChangedEvent = "onActionChanged";

const PHOTON_APP_ID = environment.PHOTON_REALTIME_APP_ID;
export class PhotonClient extends Photon.LoadBalancing.LoadBalancingClient {
    public events = new EventEmitter();

    public rooms: Room[] = [];

    constructor() {
        super(Photon.ConnectionProtocol.Wss, PHOTON_APP_ID, "1.0");
        this.setLogLevel(Exitgames.Common.Logger.Level.WARN);
    }

    public async start() {
        if (this.isConnectedToMaster()) {
            return;
        }

        this.connectToRegionMaster("usw");

        await waitUntil(
            () =>
                this.state ===
                Photon.LoadBalancing.LoadBalancingClient.State.JoinedLobby,
        );
    }

    public onJoinRoom(createdByMe: boolean) {}

    // initial room list
    public onRoomList(rooms: Photon.LoadBalancing.RoomInfo[]) {
        this.rooms = rooms.map((room) => {
            const sid = room.getCustomProperty("sid");
            return {
                name: room.name,
                sid,
            };
        });
        this.events.emit("rooms", this.rooms);
    }

    public onMyRoomPropertiesChange(): void {}

    public onActorJoin(actor: Photon.LoadBalancing.Actor): void {
        this.events.emit("onActorJoin", {
            id: actor.actorNr,
        } as Actor);
    }

    public onActorLeave(
        actor: Photon.LoadBalancing.Actor,
        cleanup: boolean,
    ): void {
        this.events.emit("onActorLeave", {
            id: actor.actorNr,
        } as Actor);
    }

    // room list updates
    public onRoomListUpdate(
        rooms: Photon.LoadBalancing.RoomInfo[],
        roomsUpdated: Photon.LoadBalancing.RoomInfo[],
        roomsAdded: Photon.LoadBalancing.RoomInfo[],
        roomsRemoved: Photon.LoadBalancing.RoomInfo[],
    ) {
        this.onRoomList(rooms);
    }

    public onActorPropertiesChange(actor: Photon.LoadBalancing.Actor): void {
        this.events.emit(onActorPropertiesChangedEvent, actor);
    }

    public onEvent(code: number, content: Event, actorNr: number) {
        // console.log("onEvent", code, content.type);
        this.events.emit(content.type, content);
        // console.log(`PHOTON EVENT ${content.type} : ${content}`);
    }
}

export const waitUntil = (condition: () => boolean) => {
    return new Promise<void>((resolve, reject) => {
        const intervalId = setInterval(() => {
            if (condition()) {
                clearInterval(intervalId);
                resolve();
            }
        }, 30);
    });
};
